import { createTheme } from '@mui/material/styles';

declare module "@mui/material/styles/createPalette" {
  interface CommonColors {
    neutral: string;
    white: string;
    black: string;
    border: string;
    surface: string;
  }
}
declare module '@mui/material/styles' {
  interface Palette {
    surface: Palette['primary']
    neutral: Palette['primary']
    border:  Palette['primary']
    white:  Palette['primary']
    transparent: Palette['primary']
  }
  interface PaletteColor {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  main: string;
  600: string;
  700: string;
  800: string;
  900: string;
  contrastText: string;
}
  interface PaletteOptions {
    neutral: PaletteOptions['primary']
    white: PaletteOptions['primary']
    black: PaletteOptions['primary']
    surface: PaletteOptions['primary']
    border:PaletteOptions['primary']
  }
}
declare module "@mui/material/styles" {
  interface TypographyVariants {
    h7: React.CSSProperties;
    body3?: React.CSSProperties;
  }
  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h7?: React.CSSProperties;
    body3?: React.CSSProperties;
  }
}

declare module '@mui/material/styles/createTypography' {
  interface TypographyOptions {
    fontWeightThin: number
    fontWeightSemiBold: number
    fontWeightExtraBold: number
    fontWeightBlack: number
    h7: object
    body3: object
  }

  interface Typography {
    fontWeightThin:number
    fontWeightSemiBold: number
    fontWeightExtraBold: number
    fontWeightBlack: number
    h7: object
    body3: object
  }
}
declare module '@mui/material/Typography'{
  interface TypographyPropsVariantOverrides {
    h7: true;
    body3: true;
  }
    interface TypographyPropsColorOverrides{
    white: true;
    black: true;
    neutral: true;
    warning: true,
    error: true,
  }
  interface TypographyPropFontweightOverrides {
    200:true
    400:true;
    500:true;
    600:true;
    700: true;
    800: true;
    900: true;
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    pbcontained: true;
    pboutlined: true;
    // whitetext: true;
    // whitecontained: true;
    // primarycontained: true;
  }
  interface ButtonPropsColorOverrides{
    neutral: true
    white: true
    black: true
  }
  }
  declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides{
    white: true
    neutral:true
  }
}
declare module '@mui/material/CircularProgress'{
  interface CircularProgressPropsColorOverrides{
    neutral:true
  }
}

declare module '@mui/material/LinearProgress' {
  interface LinearProgressPropsColorOverrides{
    neutral: true
  }
}
declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides{
    white: true;
    black: true;
    neutral: true;
  }
}

declare module '@mui/material/Chip' {
    interface ChipPropsVariantOverrides {
    semifilled: true;
    pboutlined: true;
  }
  interface ChipPropsColorOverrides{
    neutral: true;
    white: true
    black: true
  }
}

declare module '@mui/material/Tabs' {
  interface TabsPropsIndicatorColorOverrides {
      warning: true;
      neutral:true;
  }
}

declare module '@mui/material/Tab' {
  interface TabsPropsTextColorOverrides {
      warning: true;
  }
}
const theme = createTheme({
  //  breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 900,
  //     lg: 1200,
  //     xl: 1440,
  //   },
  //   },
  // typography: {
  //   fontWeightThin: 200,
  //   fontWeightSemiBold: 600,
  //   fontWeightExtraBold: 800,
  //   fontWeightBlack: 900,
  //   fontFamily: [
  //     'Roboto',
  //     '-apple-system',
  //     'BlinkMacSystemFont',
  //     '"Segoe UI"',
  //     '"Helvetica Neue"',
  //     'sans-serif',
  //     '"Apple Color Emoji"',
  //     '"Segoe UI Emoji"',
  //     '"Segoe UI Symbol"',
  //   ].join(','),
  //   h1: {
  //     fontSize: '3.815rem', // 61.04px
  //     fontWeight: 400,
  //     lineHeight: 4.5, // 72px
  //   },
  //   h2: {
  //     fontSize: '3.052rem', // 48.83px
  //     fontWeight: 400,
  //     lineHeight: 4, // 64px
  //   },
  //   h3: {
  //     fontSize: '2.441rem', // 39.06px
  //     fontWeight: 400,
  //     lineHeight: 3.5, // 56px
  //   },
  //   h4: {
  //     fontSize: '1.953rem', // 31.25px
  //     fontWeight: 400,
  //     lineHeight: 2.5, // 40px
  //   },
  //   h5: {
  //     fontSize: '1.563rem', // 25px
  //     // fontWeight: 400,
  //     lineHeight: 2.5, // 40px
  //   },
  //   h6: {
  //     fontSize: '1.25rem', // 20px
  //     fontWeight: 500,
  //     lineHeight: 2, // 32px
  //   },
  //   h7: {
  //     fontSize: '1rem', // 16px
  //     fontWeight: 400,
  //     lineHeight: 1.5, // 24px
  //   },
  //   caption:{ //caption uses span as semantic element
  //     fontSize: '1rem', // 16px
  //     fontWeight: 400,
  //     lineHeight: 1.5, // 24px
  //   },
  //   subtitle1: {
  //       fontSize: '1rem', // 16px
  //     fontWeight: 500,
  //     lineHeight: 1.5, // 24px
  //   },
  //   subtitle2: {
  //     fontSize: '0.875rem', // 14px
  //     fontWeight: 600,
  //     lineHeight: 1.5, // 24px
  //   },
  //   body1: {
  //     fontWeight: 600,
  //     fontSize: '0.8rem', // 12.80px
  //     lineHeight: 1.5, // 24px
  //   },
  //   body2: {
  //    fontSize: '0.64rem', // 10.24px
  //     fontWeight: 700,
  //     lineHeight: 1.5, // 24px
  //   },
  //   body3: {
  //   fontWeight: 700,
  //     fontSize: '0.512rem', // 8.19px
  //     lineHeight: 1, // 16px
  //   },
  //   // button: {
  //   //   fontWeight: 600,
  //   //   fontSize: '0.75rem', // 12px
  //   //   lineHeight: 1.125, // 18px
  //   // },
  //   // overline: {},
  // },
 
  // palette: {
  //   mode: 'light',
  //   error: {
  //     50:'#fae8eb',
  //     100:'#f0b6c0',
  //     200:'#e993a2',
  //     300:'#e06277',
  //     400:'#d9435d',
  //     main:'#d01434',
  //     600:'#bd122f',
  //     700:'#940e25',
  //     800:'#720b1d',
  //     900:'#570816',
  //     contrastText: '#FFF',
  //   },
  //   warning: {
  //     50:'#fff1e9',
  //     100:'#ffd5ba',
  //     200:'#ffc099',
  //     300:'#fea36b',
  //     400:'#fe914e',
  //     main:'#fe7622',
  //     600:'#e76b1f',
  //     700:'#b45418',
  //     800:'#8c4113',
  //     900:'#6b320e',
  //     contrastText: '#FFF',
  //   },
  //   neutral: {
  //     50:'#e9eced',
  //     100:'#b9c3c8',
  //     200:'#98a5ae',
  //     300:'#687c88',
  //     400:'#4b6371',
  //     main:'#1e3c4e',
  //     600:'#1b3747',
  //     700:'#152b37',
  //     800:'#11212b',
  //     900:'#0d1921',
  //     contrastText: '#FFF'
  //   },
  //   primary: {
  //     50:'#ecf5f1',
  //     100:'#c3dfd3',
  //     200:'#a5d0bd',
  //     300:'#7cbb9f',
  //     400:'#63ad8d',
  //     main:'#3c9970',
  //     600:'#378b66',
  //     700:'#2b6d50',
  //     800:'#21543e',
  //     900:'#19402f',
  //     contrastText: '#FFF',
  //   },
  //   secondary: {
  //     50:'#e6e8ff',
  //     100:'#b0b8ff',
  //     200:'#8a95ff',
  //     300:'#5465ff',
  //     400:'#3347ff',
  //     main:'#0019ff',
  //     600:'#0017e8',
  //     700:'#0012b5',
  //     800:'#000e8c',
  //     900:'#000b6b',
  //     contrastText: '#FFF',
  //   },
  //   surface: {
  //     main: '#FFFF',
  //     contrastText: '#000',
  //   },
  //   background: {
  //     default: '#F0F4F2',
  //   },
  //   text: {
  //     primary: '#1e3c4e',
  //   },
  //   // error: {
  //   //   light:'#EE515120',
  //   //   main: '#EE5151',
  //   //   contrastText: '#FFFFFF',
  //   // },
  //   // warning: {
  //   //   light: '#fff0de',
  //   //   main: '#fd9a28',
  //   // },
  //   success: {
  //     light: '#00936810',
  //     main: '#009368',
  //   },
  //   info: {
  //     main: '#fff'
  //   },
  //   border: {
  //     light: '#F8F8FA',
  //     main: '#E8E8ED',
  //     dark: '#C2C6D4',
  //   },
  //   white: {
  //     main: '#fff'
  //     // contrastText: '#001762',
  //     // light: '#E5E5E5'
  //   },
  //   black: {
  //     main: '#000'
  //     // contrastText: '#fff',
  //   },
  // },
  // shadows: [
  //   'none', // 0
  //   '0px 1px 0px 0px rgba(0, 0, 0, 0.05)', // 1
  //   'none', // 2
  //   'none', // 3
  //   'none', // 4
  //   'none', // 5
  //   'none', // 6
  //   'none', // 7
  //   'none', // 8
  //   'none', // 9
  //   'none', // 10
  //   'none', // 11
  //   'none', // 12
  //   'none', // 13
  //   'none', // 14
  //   'none', // 15
  //   'none', // 16
  //   'none', // 17
  //   'none', // 18
  //   'none', // 19
  //   'none', // 20
  //   'none', // 21
  //   'none', // 22
  //   'none', // 23
  //   'none', // 24
  // ],

  // components: {
    
  //   MuiAppBar: {
  //     styleOverrides: {
  //       root: ({ theme }) => ({
  //         backgroundColor: theme.palette.surface.main,
  //         color: theme.palette.surface.contrastText,
  //         boxShadow: theme.shadows[1]
  //       }),
  //     },
  //   },
  //   MuiTypography: {
  //     defaultProps:{
  //       variantMapping: {
  //         // Map the new variant to render a <h1> by default
  //         h7: 'h6',
  //       }
  //   },
  // },
   
  //   //   styleOverrides: {
  //   //     root: {
  //   //       textTransform: 'capitalize',
  //   //     },
  //   //   },
  //   // },
  //   // MuiFormControlLabel: {
  //   //   styleOverrides: {
  //   //     root: ({ theme }) => ({
  //   //       color: theme.palette.secondary.main,
  //   //     }),
  //   //   },
  //   // },
  //   // MuiToggleButton: {
  //   //   styleOverrides: {
  //   //     root: ({ theme }) => ({
  //   //       textTransform: 'capitalize',
  //   //       borderColor: theme.palette.border.main,
  //   //       '&:hover': {
  //   //         backgroundColor: theme.palette.primary.light,
  //   //       },
  //   //       '&.Mui-selected': {
  //   //         outlineColor: theme.palette.primary.main,
  //   //         outline: '1px solid',
  //   //         color: theme.palette.primary.main,
  //   //         backgroundColor: theme.palette.primary.light,
  //   //         '&:hover': {
  //   //           backgroundColor: theme.palette.primary.light,
  //   //         },
  //   //       },
  //   //     }),
  //   //   },
  //   // },
  //   // MuiToolbar: {
  //   //   styleOverrides: {
  //   //     root: {
  //   //       height: '4.5rem',
  //   //     },
  //   //   },
  //   // },
  //   MuiAvatar: {
  //     styleOverrides: {
  //       root: {
  //         height: '2.5rem',
  //         width: '2.5rem',
  //       },
  //     },
  //   },
  //   //   styleOverrides: {
  //   //     root: ({ theme }) => ({
  //   //       color: theme.palette.secondary.main,
  //   //       paddingX: 16,
  //   //       paddingY: 8,

  //   //     }),
  //   //   },
  //   // },
  //   MuiInputBase:{
  //     styleOverrides: {
  //       root: () => ({
  //         // default input font required to be 16px to stop zoom in issue on mobile screen.
  //         fontSize:'1rem',
  //         fontWeight:500,
  //       })
  //     }
  //   },
  //   MuiTab:{
  //     styleOverrides:{
  //       root: ({ ownerState, theme }: { ownerState: any, theme: any }) => ({
  //        textTransform: 'none',
  //        ...(ownerState.color ==='warning'&&{
  //         color:'warning.500'
  //        })
  //       })
  //     }
  //   },
  //   MuiPaper:{
  //     styleOverrides:{
  //       root: ({ ownerState, theme }: { ownerState: any, theme: any }) => ({
  //        borderRadius: 8,
  //        boxShadow:theme.shadows[1]
  //       })
  //     }
  //   },
  //   MuiButton: {
  //     styleOverrides: {
  //       root: ({ ownerState, theme }: { ownerState: any, theme: any }) => ({
  //         textTransform: 'capitalize',
  //         ...(ownerState.variant === 'pbcontained' && {
  //           color: theme.palette.primary.contrastText,
  //           backgroundColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary.main 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning.main
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral.main
  //             : ownerState.color === "error" 
  //             ? theme.palette.error.main
  //             : theme.palette.primary.main,
  //           '&:hover':{
  //             backgroundColor: ownerState.color === "secondary" 
  //               ? theme.palette.secondary.dark 
  //               : ownerState.color === "warning" 
  //               ? theme.palette.warning[700]
  //               : ownerState.color === "neutral" 
  //               ? theme.palette.neutral[700]
  //               : ownerState.color === "error" 
  //               ? theme.palette.error[700]
  //               : theme.palette.primary.dark,
  //           },
  //           '&:disabled':{
  //             backgroundColor: theme.palette.neutral[50],
  //             borderColor: theme.palette.neutral[50]
  //           },
  //          border:1,
  //           borderColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary.main 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning.main
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral.main
  //             : ownerState.color === "error" 
  //             ? theme.palette.error.main
  //             : ownerState.color === "white" 
  //             ? theme.palette.white.main
  //             : theme.palette.primary.main,
  //           borderStyle: 'solid',
  //           borderRadius: 24,
  //           fontWeight: 700,
  //           // fontSize: ownerState.size === 'large' ? 16 : ownerState.size === 'small' ? 12.80 : 14,
          
  //           textAlign: 'center',
  //         }),
  //         ...(ownerState.variant === 'pboutlined' && {
  //           color: ownerState.color === "secondary" 
  //             ? theme.palette.secondary.main 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning.main
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral.main
  //             : ownerState.color === "error" 
  //             ? theme.palette.error.main
  //             : ownerState.color === "white" 
  //             ? theme.palette.white.main
  //             :theme.palette.primary.main,
  //           backgroundColor: ownerState.color === "white" 
  //             ? theme.palette.transparent
  //             :theme.palette.primary.contrastText,
  //           '&:hover':{
  //             backgroundColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary[50] 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning[50]
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral[50]
  //             : ownerState.color === "error" 
  //             ? theme.palette.error[50]
  //             : ownerState.color === "white" 
  //             ? 'rgba(0, 0, 0, 0.1)'
  //             : theme.palette.primary[50],
  //           },
  //           '&:disabled':{
  //             // backgroundColor: theme.palette.neutral[50],
  //             borderColor: theme.palette.neutral[50]
  //           },
  //           border:1,
  //           borderColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary.main 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning.main
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral.main
  //             : ownerState.color === "error" 
  //             ? theme.palette.error.main
  //             : ownerState.color === "white" 
  //             ? theme.palette.white.main
  //             : theme.palette.primary.main,
  //           borderStyle: 'solid',
  //           borderRadius: 24,
  //           fontWeight: 700,
  //           // fontSize: ownerState.size === 'large' ? 16 : ownerState.size === 'small' ? 12.80 : 14,
  //           textAlign: 'center',
  //         }),
  //         ...(ownerState.size === 'small' && {
  //           fontSize: 10.24,
  //           padding: '3px 10px'
  //         }),
  //             ...(ownerState.size === 'large' && {
  //           fontSize:16,
  //         }),
  //       }),
  //     },
  //   },
  //    MuiChip: {
  //     styleOverrides: {
  //       root: ({ ownerState, theme }) => ({
  //                     // fontSize: ownerState.size === 'large' ? 16 : ownerState.size === 'small' ? 12.80 : 14,
  //         fontSize: 14,
  //         ...(ownerState.size) === 'small' && {
  //          fontSize: 12.80
  //         },
  //         ...(ownerState.variant === 'semifilled' && {
  //           ...(ownerState.color === 'primary' && {
  //             backgroundColor: theme.palette.primary[50],
  //             color: theme.palette.primary.main,
  //           }),
  //           ...(ownerState.color === 'neutral' && {
  //             backgroundColor: theme.palette.neutral[50],
  //             color: theme.palette.neutral.main,
  //           }),
  //           ...(ownerState.color === 'warning' && {
  //             backgroundColor: theme.palette.warning[50],
  //             color: theme.palette.warning.main,
  //           }),
  //               ...(ownerState.color === 'error' && {
  //             backgroundColor: theme.palette.error[50],
  //             color: theme.palette.error.main,
  //           }),
  //           ...(ownerState.color === 'default' && {
  //             backgroundColor: theme.palette.secondary.light,
  //             color: theme.palette.secondary.main,
  //           }),
  //         }),

  //         ...(ownerState.variant === 'pboutlined' && {
  //           color: ownerState.color === "secondary" 
  //             ? theme.palette.secondary.main 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning.main
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral.main
  //             : ownerState.color === "error" 
  //             ? theme.palette.error.main
  //             : ownerState.color === "white" 
  //             ? theme.palette.white.main
  //             :theme.palette.primary.main,
  //           backgroundColor: ownerState.color === "white" 
  //             ? theme.palette.background.default
  //             :theme.palette.primary.contrastText,
  //           '&:hover':{
  //             backgroundColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary[50] 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning[50]
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral[50]
  //             : ownerState.color === "error" 
  //             ? theme.palette.error[50]
  //             : ownerState.color === "white" 
  //             ? 'rgba(0, 0, 0, 0.1)'
  //             : theme.palette.primary[50],
  //           },
  //           border:1,
  //           borderColor: ownerState.color === "secondary" 
  //             ? theme.palette.secondary[100] 
  //             : ownerState.color === "warning" 
  //             ? theme.palette.warning[100]
  //             : ownerState.color === "neutral" 
  //             ? theme.palette.neutral[100]
  //             : ownerState.color === "error" 
  //             ? theme.palette.error[100]
  //             : ownerState.color === "white" 
  //             ? theme.palette.white[100]
  //             : theme.palette.primary[100],
  //           borderStyle: 'solid',
  //           borderRadius: 24,
  //           fontWeight: 700,
  //           textAlign: 'center',
  //         }),
  //       }),
  //     },
  //   },
  // },
},
);

export default theme;
